import { DEFAULT_COUNTRY_ZOOM_LEVEL } from '../../config/zoomLevelConfig'

export const highwayRouteColor = (tags: string[], highwayTag?: string) => {
  const route_highway = (process.config as any).style.legend.route_highway
  const route = (process.config as any).style.legend.route
  if (highwayTag) {
    return tags && tags.indexOf(highwayTag) > -1 ? route_highway : route
  } else {
    return route
  }
}

// 根据不同zoom显示不同的级别
export const zoomToRatio = (zoom?: number) => {
  if (zoom) {
    if (zoom >= DEFAULT_COUNTRY_ZOOM_LEVEL) {
      return 1.4
    } else {
      return 0.8
    }
  } else {
    return 1
  }
}
